const capitalize = string => `${string.charAt(0).toUpperCase()}${string.substr(1)}`;

export {capitalize}